import TimeAgo from "react-timeago-i18n";
import {UsersIcon, EyeSlashIcon} from "@phosphor-icons/react";
import { TIMEAGO_TEXT } from 'utilities/global.variables';
import { formatCurrency, ownedValue } from 'utilities/global.functions';

const TableRowCard = ({item, editEntry, isAsset}) => {
  const {name, description, valuation, ownership, include_networth} = {...item}

  const value = Math.abs(ownedValue(valuation, ownership))

  return (
    <div className="table-row" onClick={() => editEntry(item)}>
      <div className="flex col small-gap">
        <div className="flex row medium-gap center">
          <p className="medium truncate-1">{name}</p>
          {item.ownership < 100 && (
            <div className="icon medium">
              <UsersIcon />
            </div>
          )}
          
          {!include_networth && (
            <div className="icon medium">
              <EyeSlashIcon />
            </div>
          )}
        </div>
        <div className="">
          <p className="regular o60">{description}</p>
        </div>
      </div>
      <div className="flex col end small-gap">
        <p className="number medium">{formatCurrency(value)}</p>
        <p className=" regular o60 updated"> <TimeAgo date={item.updated} locale="en" minPeriod={1} maxPeriod={300} text={TIMEAGO_TEXT} /> </p>
      </div>
    </div>
  );
};

export default TableRowCard;
